export default __webpack_public_path__ + "static/media/progressStart.c420d2bd.svg";